var render = function render(){var _vm=this,_c=_vm._self._c;return _c('El',_vm._b({staticClass:"checkbox",class:_vm.classes},'El',_vm.$attrs,false),[_c('input',_vm._g({attrs:{"id":_vm.id,"type":"checkbox"}},_vm.$listeners)),_c('label',{attrs:{"for":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }